module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-container",
    attrs: {
      "id": "privacy"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "body-content"
  }, [_c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("腾讯Bugly SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("收集崩溃信息，提升App质量，提供异常日志分析服务")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("在程序异常时")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("个人信息收集类型：")]), _vm._v(" "), _c('div', [_vm._v("设备唯一识别码(IMEI/MEID/AndroidID/IDFA/OPENUDID/IDFV/出厂序列号/SIM卡IMSI)")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("深圳市腾讯计算机系统有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("华为推送SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("提供消息推送服务")]), _vm._v(" "), _c('div', [_vm._v("统计华为推送SDK接口调用成功率。")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("手机在后台时，需要收到会议邀请时进行提醒展示")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("个人信息收集类型：")]), _vm._v(" "), _c('div', [_vm._v("应用基本信息、应用内设备标识符、设备的硬件信息、系统基本信息和系统设置信息")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("华为软件技术有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("友盟SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("内容分享，用户行为分析")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("内容分享到第三方软件")]), _vm._v(" "), _c('div', [_vm._v("用户使用功能次数记录")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("个人信息收集类型：")]), _vm._v(" "), _c('div', [_vm._v("设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("友盟同欣(北京)科技有限公司、北京瑞讯灵通科技有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("小米推送SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("为用户提供推送")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("手机在后台时，需要收到会议邀请时进行提醒展示")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("个人信息收集类型：")]), _vm._v(" "), _c('div', [_vm._v("Mac地址、WiFi SSID、访问电话状态、获取网络信息、设备型号/名称、设备制造商、手机品牌、系统的API级别数字/字符、运行程序列表")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("北京小米科技有限责任公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("VIVO推送SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("向VIVO手机用户推送消息")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("个人信息收集类型：")]), _vm._v(" "), _c('div', [_vm._v("获取任务信息、获取网络信息、设备制造商、系统的API级别数字/字符、运行程序列表")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("维沃移动通信有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("OPPO推送SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("向OPPO手机用户推送消息")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("个人信息收集类型：")]), _vm._v(" "), _c('div', [_vm._v("系统的API级别数字/字符")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("OPPO广东移动通信有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("极光推送SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("向OPPO手机用户推送消息")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集个人信息类型：")]), _vm._v(" "), _c('div', [_vm._v("获取任务信息、获取网络信息、设备制造商、系统的API级别数字/字符、运行程序列表")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("深圳市和讯华谷信息技术有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("阿里云OSS对象存储SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("上传图片、缓存数据")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集个人信息类型：")]), _vm._v(" "), _c('div', [_vm._v("允许联网、获取网络状态、判断网络状态、获取本地存储")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("北京阿里巴巴云计算技术有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("声网SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("提供视频与音频会议功能")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集个人信息类型：")]), _vm._v(" "), _c('div', [_vm._v("设备类型、设备型号、CPU信息、电池电量信息、操作系统信息")]), _vm._v(" "), _c('div', [_vm._v("收发端用户ID、用户属性、频道信息、使用时长、频道内设置名称、日志")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("上海兆言网络科技有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("魅族PUSH")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("向魅族手机用户消息推送")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集个人信息类型：")]), _vm._v(" "), _c('div', [_vm._v("网卡（MAC）地址、国际移动设备识别码（IMEI）、独立设备标识符、IP地址、设备型号、操作系统版本、电池、信号强度")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("珠海市魅族科技有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("MobTech ShareSDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("提供社交分享、第三方登录社交分享、第三方登录功能")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("内容分享和第三方登录")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集个人信息类型：")]), _vm._v(" "), _c('div', [_vm._v("系统信息；WIFI状态信息；应用列表信息；基站信息；地理位置")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("上海游昆信息技术有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("支付宝SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("支付")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("购买VIP服务等")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("个人信息收集类型：")]), _vm._v(" "), _c('div', [_vm._v("设备信息（如IMEI、IMSI、SIM卡序列号、MAC地址、Android ID、SSID、BSSID、设备基础信息【机型\\厂商等】）、网络信息。")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("支付宝(中国)网络技术有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "sub-title group"
  }, [_vm._v("SDK名称：")]), _vm._v(" "), _c('div', [_vm._v("微信SDK")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("支付")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("购买VIP服务等")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("个人信息收集类型：")]), _vm._v(" "), _c('div', [_vm._v("MAC地址、唯一设备识别码")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集方式：")]), _vm._v(" "), _c('div', [_vm._v("SDK对手机进行本地采集")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方公司名称：")]), _vm._v(" "), _c('div', [_vm._v("深圳市腾讯计算机系统有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("第三方SDK隐私政策：")]), _vm._v(" "), _vm._m(12)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://privacy.qq.com/document/preview/179ae701076241418eaf276f7595ee54"
    }
  }, [_vm._v("https://privacy.qq.com/document/preview/179ae701076241418eaf276f7595ee54")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177"
    }
  }, [_vm._v("https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://www.umeng.com/page/policy"
    }
  }, [_vm._v("https://www.umeng.com/page/policy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://dev.mi.com/console/doc/detail?pId=1822"
    }
  }, [_vm._v("https://dev.mi.com/console/doc/detail?pId=1822")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://dev.vivo.com.cn/documentCenter/doc/652"
    }
  }, [_vm._v("https://dev.vivo.com.cn/documentCenter/doc/652")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://open.oppomobile.com/wiki/doc#id=10288"
    }
  }, [_vm._v("https://open.oppomobile.com/wiki/doc#id=10288")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://www.jiguang.cn/license/privacy"
    }
  }, [_vm._v("https://www.jiguang.cn/license/privacy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.131995.J_9220772140.87.581169fdsILQ3y"
    }
  }, [_vm._v("http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.131995.J_9220772140.87.581169fdsILQ3y")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://www.agora.io/cn/privacy-policy"
    }
  }, [_vm._v("https://www.agora.io/cn/privacy-policy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://www.meizu.com/legal.html"
    }
  }, [_vm._v("https://www.meizu.com/legal.html")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://www.mob.com/about/policy"
    }
  }, [_vm._v("https://www.mob.com/about/policy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://docs.open.alipay.com/54"
    }
  }, [_vm._v("https://docs.open.alipay.com/54")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl"
    }
  }, [_vm._v("https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f091ca06", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f091ca06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/3dsharelist/3dsharelist.vue
// module id = 448
// module chunks = 24